'use client';

import dynamic from 'next/dynamic';

export const PlausibleScript = dynamic(() => import('./plausible-script'), {
  ssr: false,
});
